module.exports = __webpack_public_path__ + "static/media/BM.63abd5d8.png";